import { PropsWithChildren } from "react";

import { cn } from "@utils/tailwind.util";

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  className?: string;
}

export function TagLabel({ className, children }: PropsWithChildren<Props>) {
  return (
    <span
      className={cn(
        "max-w-full text-sm font-medium text-gray-950 dark:text-white text-overflow-ellipsis non-selectable",
        className
      )}
    >
      {children}
    </span>
  );
}
